import LangEnum from '../../../../lang/LangEnum';
import { MultiStaticOptionFilter } from '../../../Crud/filters/sharedBetweenFilters/types';
import { FilterFactoryGetLabelParams, IFilterHelperFactory } from '../filter-factory.types';
import { getMultiOptionFriendlyLabel } from '../filter-factory.utils';

class StaticFilterHelper implements IFilterHelperFactory {
  constructor(private readonly filter: MultiStaticOptionFilter) {}

  getChipLabel({ translate }: FilterFactoryGetLabelParams) {
    const selectedOptions = this.filter.multiStaticOptionsArgs?.selectedOptions;

    const selectedLabels = getMultiOptionFriendlyLabel(
      this.filter.multiStaticOptionsArgs.allOptions,
      selectedOptions,
    );

    if (selectedLabels.length >= 3) {
      return `${this.filter.title}: ${selectedLabels.length} ${translate(LangEnum.GLOBAL_SELECTED_PLURAL)}`;
    }

    return `${this.filter.title}: ${selectedLabels.join(', ')}`;
  }

  getFriendlyLabel(): string {
    const selectedOptions = this.filter.multiStaticOptionsArgs?.selectedOptions;

    const selectedText = getMultiOptionFriendlyLabel(
      this.filter.multiStaticOptionsArgs.allOptions,
      selectedOptions,
    ).join(', ');

    return selectedText;
  }

  hasValue() {
    return this.filter.multiStaticOptionsArgs?.selectedOptions?.length > 0;
  }

  isLoading() {
    return false;
  }
}

export default StaticFilterHelper;
